import HostedDesktopLayout from '../../../layouts/DesktopLayout';
import HostedDoneScreen from '../shared/DoneScreen';
import { type DonePageProps } from '../../../chulak/ChulakSession';

export default function HostedDesktopDonePage({
  onComplete,
  continueInApp,
}: DonePageProps) {
  return (
    <HostedDesktopLayout>
      <HostedDoneScreen onComplete={onComplete} continueInApp={continueInApp} />
    </HostedDesktopLayout>
  );
}
